module.exports = __webpack_public_path__ + "img/step2.4b959805.png";